import addressbook from "./addressbook";
// import adminusers from "./adminusers";
import anniversary from "./anniversary";
import billing from "./billing";
import calendar from "./calendar";
// project-imports
import chat from "./chat";
import clients from "./clients";
// third-party
import { combineReducers } from "redux";
import companyReducer from "./company";
import invoice from "./invoice";
import ivrStore from "./ivrstore";
import kanban from "./kanban";
import menu from "./menu";
import messaging from "./messaging";
import options from "./options";
import { persistReducer } from "redux-persist";
import productReducer from "./product";
import senderId from "./senderid";
import setups from "./setups";
import snackbar from "./snackbar";
import storage from "redux-persist/lib/storage";
import usersmanagement from "./users";
import ussdStore from "./ussdstore";

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  chat,
  calendar,
  menu,
  snackbar,
  ussdStore,
  product: productReducer,
  kanban,
  invoice,
  anniversary,
  senderId,
  clients,
  billing,
  setups,
  contacts: addressbook,
  company: persistReducer(
    {
      key: "company",
      storage,
      keyPrefix: "user-company"
    },
    companyReducer
  ),
  options,
  usersmanagement,
  messaging,
  ivrStore
});

export default reducers;
